import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    localAccountList: [],
    vehicleList: [],
    topupList: {
        original_transaction: {
            items: null,
        },
    },
    userOverallSummary: {
        total_all: null,
        total_active: null,
        total_inactive: null,
    },
    fuelCodes: [],
    totalTopupCount: 0,
};

const mutations = {
    setTotalTopupCount(state, count) {
        state.totalTopupCount = count;
    },

    [type.SET_LOCAL_ACCOUNT_LIST](state, local_account) {
        state.localAccountList = local_account;
    },

    [type.ADD_LOCAL_ACCOUNT](state, local_account) {
        state.localAccountList = local_account;
    },

    [type.ADD_VEHICLE](state, local_account) {
        state.vehicleList = local_account;
    },

    [type.ADD_TOPUP](state, local_account) {
        state.topupList = local_account;
    },

    setLocalAccount(state, local_account) {
        state.localAccountList = local_account;
    },

    setTopup(state, local_account) {
        state.topupList = local_account;
    },

    setVehicle(state, local_account) {
        state.vehicleList = local_account;
    },

    setUserOverallSummary(state, local_account) {
        state.userOverallSummary = local_account;
    },

    setFuelCodes(state, fuelCodes) {
        state.fuelCodes = fuelCodes;
    },
};

const getters = {
    hasLocalAccount(state) {
        return state.localAccountList.id !== null;
    },

    local_accounts(state) {
        return state.localAccountList;
    },

    vehicles(state) {
        return state.vehicleList;
    },

    topup(state) {
        return state.topupList;
    },

    userOverallSummary(state) {
        return state.userOverallSummary;
    },

    grandTotal(state) {
        let totalAmount = Math.abs(state.topupList.amount);

        if (state.topupList.type == 'COMPLETE') {
            totalAmount = Math.abs(state.topupList.original_amount);
        }

        return totalAmount;
    },

    fuelCodes(state) {
        return state.fuelCodes;
    },
};

const actions = {
    updateLocalAccount({ commit, dispatch }, local_account) {
        let route = Laroute.route('franchise.localaccount.update', {
            outletId: parseInt(local_account.outlet_id),
            userId: parseInt(local_account.account_id),
        });
        startLoading(dispatch, 'save-local-account');

        return axios
            .patch(route, local_account)
            .then(res => {
                endLoading(dispatch, 'save-local-account');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-local-account');
                throw err;
            });
    },

    updateVehicle({ commit, dispatch }, local_account) {
        let route = Laroute.route('franchise.authorised.update', {
            outletId: parseInt(local_account.outlet_id),
            vehicle_id: parseInt(local_account.id),
        });
        startLoading(dispatch, 'save-vehicle');

        return axios
            .patch(route, local_account)
            .then(res => {
                endLoading(dispatch, 'save-vehicle');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-vehicle');
                throw err;
            });
    },

    createLocalAccount({ commit, dispatch }, local) {
        let route = Laroute.route('franchise.localaccount.store');
        startLoading(dispatch, 'save-local-account');

        return axios
            .post(route, local)
            .then(res => {
                commit(type.ADD_LOCAL_ACCOUNT, res.data);
                endLoading(dispatch, 'save-local-account');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-local-account');
                throw err;
            });
    },

    createVehicle({ commit, dispatch }, local_account) {
        let route = Laroute.route('franchise.authorised.store', {
            outletId: parseInt(local_account.outlet_id),
            userId: parseInt(local_account.user_id),
        });
        startLoading(dispatch, 'save-vehicle');

        return axios
            .post(route, local_account)
            .then(res => {
                commit(type.ADD_VEHICLE, res.data);
                endLoading(dispatch, 'save-vehicle');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-vehicle');
                throw err;
            });
    },

    createTopup({ commit, dispatch }, local_account) {
        let route = Laroute.route('franchise.topup.store');
        startLoading(dispatch, 'save-topup');

        return axios
            .post(route, local_account)
            .then(res => {
                commit(type.ADD_TOPUP, res.data);
                endLoading(dispatch, 'save-topup');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-topup');
                throw err;
            });
    },

    getTotalTopupCount({ commit, dispatch }, data) {
        commit('setTotalTopupCount', data);
    },

    async getLocalAccount({ dispatch, commit }, local_account) {
        startLoading(dispatch, 'fetch-local-account');
        const url = Laroute.route('franchise.localaccount.show', {
            id: local_account.id,
            account_id: local_account.account_id,
        });

        try {
            const { data } = await axios.get(url);
            commit('setLocalAccount', data);
            endLoading(dispatch, 'fetch-local-account');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-local-account');
            throw e;
        }
    },

    async getTotalOnAccount({ dispatch, commit }, local_account) {
        startLoading(dispatch, 'fetch-total-account');
        const url = Laroute.route('franchise.localaccount.show', {
            id: local_account.id,
            account_id: local_account.account_id,
        });

        try {
            const { data } = await axios.get(url);
            commit('setLocalAccount', data);
            endLoading(dispatch, 'fetch-total-account');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-total-account');
            throw e;
        }
    },

    async getVehicle({ dispatch, commit }, local_account) {
        startLoading(dispatch, 'fetch-vehicle');
        const url = Laroute.route('franchise.authorised.show', {
            id: parseInt(local_account.id),
            vehicle_id: parseInt(local_account.vehicle_id),
        });
        try {
            const { data } = await axios.get(url);
            commit('setVehicle', data);
            endLoading(dispatch, 'fetch-vehicle');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-vehicle');
            throw e;
        }
    },

    async getTopup({ dispatch, commit }, local_account) {
        startLoading(dispatch, 'fetch-topup');
        const url = Laroute.route('franchise.topup.show', {
            id: local_account.id,
            account_id: local_account.account_id,
            transaction_id: local_account.transaction_id,
        });

        try {
            const { data } = await axios.get(url);
            commit('setTopup', data);
            endLoading(dispatch, 'fetch-topup');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-topup');
            throw e;
        }
    },

    async getUserOverallSummary({ commit, dispatch }, outletId) {
        startLoading(dispatch, 'fetch-user-summary');

        const endpoint = Laroute.route('franchise.localaccount.summary', {
            outletId,
        });

        try {
            const { data } = await axios.get(endpoint);
            commit('setUserOverallSummary', data);
            endLoading(dispatch, 'fetch-user-summary');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-user-summary');
            throw e;
        }
    },

    async generateStatement({ commit, dispatch }, data) {
        startLoading(dispatch, 'generate-on-account-statement');

        const endpoint = Laroute.route('franchise.topup.statement', {
            id: data.id,
            account_id: data.account_id,
            since: data.since,
            until: data.until,
        });

        try {
            await axios.get(endpoint);
            endLoading(dispatch, 'generate-on-account-statement');
        } catch (e) {
            endLoading(dispatch, 'generate-on-account-statement');
            throw e;
        }
    },

    async generateInvoice({ commit, dispatch }, data) {
        startLoading(dispatch, 'generate-on-account-invoice');

        const endpoint = Laroute.route('franchise.topup.invoice', {
            id: data.id,
            account_id: data.account_id,
            since: data.since,
            until: data.until,
        });

        try {
            await axios.get(endpoint);
            endLoading(dispatch, 'generate-on-account-invoice');
        } catch (e) {
            endLoading(dispatch, 'generate-on-account-invoice');
            throw e;
        }
    },

    async getFuel({ commit, dispatch }, data) {
        const endpoint = Laroute.route('franchise.localaccount.fuels');
        try {
            const { data } = await axios.get(endpoint);

            const fuelCodes = data.map(fuel => {
                return fuel.code;
            });

            commit('setFuelCodes', fuelCodes);
        } catch (e) {
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
